import { useQuery } from 'react-query';
import { BrokerAgreementApi } from '../BrokerAgreementApi';
import { BrokerAgreement } from '../types';

export const BrokerAgreementQueryKey = 'broker-agreement';

export function useBrokerAgreementQuery(
    brokerAgentId: number,
    brokerFirmId: number,
    planOnly: boolean,
    onSuccess?: (agreement: BrokerAgreement) => void
) {
    return useQuery<BrokerAgreement>(
        [BrokerAgreementQueryKey, brokerAgentId, brokerFirmId, planOnly],
        () => BrokerAgreementApi.getBrokerAgreement(brokerAgentId, brokerFirmId, planOnly),
        { onSuccess, staleTime: 0, cacheTime: 0 }
    );
}
